export default {
  userId: 'User ID',
  privacyPolicy: 'Privacy Policy',
  pl: 'Poland',
  settings: 'Settings',
  advancedSettings: 'Customize your choice',
  agreementTitle: 'We value your privacy!',
  settingsInfo: 'On this page you can find more information about purposes of data processing and the vendors that we use on our websites',
  dataAdministratorIs: 'The data controller (GDPR Art 4.7) is the following company',
  updatedAt: 'Updated at',
  acceptAll: 'Accept all',
  customizeSelection: 'Customize selection',
  saveAndClose: 'Save and exit',
  findOut: 'Find out more',
  all: 'All',
  necessary: 'Necessary',
  survey: 'Survey',
  marketing: 'Marketing',
  social: 'Social media',
  advertisement: 'Advertisement',
  cookies: 'Cookies',
  admin: 'Data controller',
  purpose: 'Purpose',
  vendor: 'Vendor',
  vendors: 'Vendors',
  name: 'Name',
  value: 'Value',
  unknown: 'Unknown',
  statistics: 'Statistics',
  functional: 'Functioning of the site',
  validity: 'Validity',
  session: 'session',
  minute: '1 minute',
  hour: '1 hour',
  day: '1 day',
  '90days': '90 days',
  week: '1 week',
  month: '1 month',
  '3months': '3 months',
  '6months': '6 months',
  year: '1 year',
  '13months': '13 months',
  '2years': '2 years',
  persistent: 'persistent'
}
